import { useState, useEffect, Fragment } from "react";
import { useFormikContext } from "formik";
import { useFormData } from "../../../contexts/FormData";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import Field from "../../../utils/FormikFields/Field";
import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";
import { InputLabel, autoCompleteDisplayLabel } from "../../../utils/Common";

import { formatGenericDate } from "../../../utils/util";

import { useInvoiceData } from "../../../contexts/InvoiceData";

import { useQuery } from '@tanstack/react-query';

import { getSoldInventoryByCustomer } from "../../Inventory/apiService";

const SelectWig = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  const { formValues, setFormValues } = useFormData() || {};

  const [serverOptions, setServerOptions] = useState(null);

  let { invoice_data } = useInvoiceData() || {};

  let repairs = values?.repairs || [];

  console.log(values, "formValues");

  const displayLabel = (option) => {
    let status;
    if (option?.status === "sold") {
      status = `Sold On ${formatGenericDate(option?.last_log_date, "short")} To ${option?.customer_name}`
    } else if (option?.status === "removed") {
      status = "Returned";
    } else {
      status = "In Stock"
    }
    let info = <div><span style={{fontWeight: "600"}}>{option?.brand_name}</span> &middot; {option?.sku} &middot; <span style={{fontStyle: "italic"}}>{status}</span></div>
    return autoCompleteDisplayLabel(option?.wig_id, info);
  }

  const { data: inventory} = useQuery({
    queryKey: ['inventory', 'by-customer', values?.customer_id],
    queryFn: () => getSoldInventoryByCustomer(values?.customer_id),
    enabled: !!values?.customer_id && !values?.repair_ticket_id
  })

  useEffect(() => {
    if (invoice_data?.wig) {
      setServerOptions([{...invoice_data.wig}]);
      setFieldValue('wig_id', invoice_data.wig.wig_id);
      if (invoice_data.wig?.inventory_id) {
        setFormValues(ofv => ({...ofv, inventory_id: invoice_data.wig.inventory_id}));
      }
    }
  }, [invoice_data?.invoice_id])

  useEffect(() => {
    if (values.backend_data_loaded) {
      let wig = {
        wig_id: values.wig_id,
        sku: values.sku,
        sold_date: values.sold_date,
        inventory_id: values.inventory_id
      }
      setServerOptions([{...wig}]);
    }
  }, [values.backend_data_loaded])

  useEffect(() => {
    if (inventory && !values?.repair_ticket_id && !invoice_data?.wig?.wig_id) {
      console.log(inventory, "inventory");
      setServerOptions(inventory);
    }
  }, [inventory])


  useEffect(() => {
    if (formValues?.inventory_id) {
      setFieldValue('wig_source', "inventory");
    } else {
      setFieldValue('wig_source', "external");
    }

  }, [values?.wig_id, formValues?.inventory_id])

  return (
    <Fragment>
      {/* <Grid size={{xs: 12, md: 6, lg: 4}}>
        <InputLabel>Wig Source</InputLabel>
        <ToggleButtonGroup size="small" color="secondary" fullWidth exclusive value={values.wig_source} onChange={(e, val) => setFieldValue('wig_source', val)} disabled={repairs.length > 0 || invoice_data?.wig?.wig_id}>
            <ToggleButton value="inventory">Customer Wig</ToggleButton>
            <ToggleButton value="external">External Wig</ToggleButton>
          </ToggleButtonGroup>
      </Grid> */}
      <Grid size={{xs: 12}}>
        <InputLabel>Wig</InputLabel>
        {/* {values?.wig_source === "external" ? <Field 
          fieldType="formField" 
          formFieldType="text" 
          name="wig_id" 
          type="text"
          disabled = {repairs.length > 0 || invoice_data?.wig?.wig_id || !values?.customer_id}
         /> : ( */}
          <AutoCompleteSolo 
            name = "wig_id"
            label = "Select Wig"
            url = "inventory"
            fieldName = "wig_id"
            displayField= "wig_id"
            // conditionStr={`&status[$eq]=sold&customer_id[$eq]=${values?.customer_id}`}
            formUpdates = {[{name: "sku", field: "sku"}, {name: "wig_sold_on", field: "date_sold"}, {name: "inventory_id", field: "inventory_id"}]}
            displayLabel = {displayLabel} 
            serverOptions={serverOptions}
            onlyPrefetch={true}
            // forceServer={true}
            disabled = {repairs.length > 0 || invoice_data?.wig?.wig_id || !values?.customer_id}
            simple={true}
          />
        {/* )} */}
      </Grid>
    </Fragment>
  )

};

export default SelectWig;